import {alias, createModelSchema, identifier, reference,} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SearchFilter extends Cloneable {
    static NONE = new SearchFilter(0, "NONE");

    static _values = [
        this.NONE,
        new SearchFilter(1, "STATE_BUILD_IDLE"),
        new SearchFilter(2, "STATE_BUILD_RUNNING"),
        new SearchFilter(3, "STATE_MINE_IDLE"),
        new SearchFilter(4, "STATE_MINE_RUNNING"),
        new SearchFilter(5, "STATE_HARVEST_IDLE"),
        new SearchFilter(6, "STATE_HARVEST_RUNNING"),
        new SearchFilter(7, "STATE_REMOVE_IDLE"),
        new SearchFilter(8, "STATE_REMOVE_RUNNING"),
        new SearchFilter(9, "STATE_READY_IDLE"),
        new SearchFilter(10, "STATE_READY_RUNNING"),
        new SearchFilter(11, "BOAT_ORDER_DELIVERY_ON"),

        new SearchFilter(12, "ITEM_MASTER_ON"),
        new SearchFilter(13, "ITEM_MASTER_OFF"),

        new SearchFilter(14, "EXCLUDE_STATE_BUILD"),
        new SearchFilter(15, "EXCLUDE_STATE_MINE"),
        new SearchFilter(16, "EXCLUDE_STATE_HARVEST"),
        new SearchFilter(17, "EXCLUDE_STATE_REMOVE"),
        new SearchFilter(18, "EXCLUDE_STATE_READY")
    ];

    static getValues() {
        return SearchFilter._values;
    }

    static getValue(id) {
        let value = SearchFilter._values.find(v => v.id === id) || null;
        console.assert(value, "unknown model: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SearchFilter.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SearchFilter) {
            return SearchFilter._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof SearchFilter) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SearchFilter());
        } else if (target instanceof SearchFilter) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SearchFilter, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});